module.exports = __webpack_public_path__ + "img/doctor-ico-white.45ac844f.svg";